import React from 'react';
import { Button } from '@ublend-npm/aulaui-next';

import { InvalidAssignmentDetails } from './assignmentType';
import {
  InvalidAssignmentText,
  ErrorIcon,
  DeleteIcon,
  VisibilityOffIcon,
  AssignmentSubtitle,
  InvalidAssignmentContainer,
} from './Assignment.styled';

export const renderInvalidAssignmentText = (
  assignment: InvalidAssignmentDetails | undefined,
) => {
  if (assignment?.deletedAt) {
    return (
      <InvalidAssignmentText>
        <DeleteIcon data-testid="DeleteIcon" />
        <AssignmentSubtitle disablePadding>
          This assignment was deleted
        </AssignmentSubtitle>
      </InvalidAssignmentText>
    );
  }

  if (assignment?.hiddenFromStudent) {
    return (
      <InvalidAssignmentText>
        <VisibilityOffIcon inSubtitle data-testid="VisibilityOffIcon" />
        <AssignmentSubtitle disablePadding>
          This assignment has been hidden by your educator
        </AssignmentSubtitle>
      </InvalidAssignmentText>
    );
  }

  return (
    <InvalidAssignmentText>
      <ErrorIcon data-testid="ErrorIcon" />
      <AssignmentSubtitle disablePadding>
        Assignment not found
      </AssignmentSubtitle>
    </InvalidAssignmentText>
  );
};

export const InvalidAssignment = ({
  assignment,
  deleteBlock,
}: {
  assignment?: InvalidAssignmentDetails;
  deleteBlock?: (() => void) | boolean;
}) => (
  <InvalidAssignmentContainer>
    {renderInvalidAssignmentText(assignment)}
    {deleteBlock && (
      <div>
        <Button type="text" size="small" onClick={deleteBlock}>
          Delete block
        </Button>
      </div>
    )}
  </InvalidAssignmentContainer>
);
